import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
/**
 * ProtectedRoute component to restrict access to certain routes
 *
 * @param {Object} props
 * @param {React.Component} props.component
 * @param {string} props.requireAuth
 * @param {string} props.path
 * @param {boolean} props.exact
 */
const ProtectedRoute = ({ component: Component, requireAuth, ...rest }) => {
  const authState = useSelector((state) => state.trackco?.auth);

  const email = useSelector((state) => state.trackco?.profile?.email);
  const sessionEmail = sessionStorage.getItem("email");

  const isAuthorized = () => {
    if (!authState) {
      if (requireAuth === "verificationRequired") {
        const sessionEmail = sessionStorage.getItem("email");
        return (
          sessionStorage.getItem("needsVerification") === "true" &&
          sessionEmail &&
          sessionEmail !== "undefined"
        );
      }
      return false;
    }

    switch (requireAuth) {
      case "loginSuccess":
        return Boolean(
          authState.isAuthenticated ||
            (authState.isLoggedIn && authState.loginCompleted)
        );
      case "verificationRequired":
        const hasEmail = Boolean(email && email.length > 0);
        const hasSessionEmail = Boolean(
          sessionEmail && sessionEmail.length > 0
        );
        return hasEmail || hasSessionEmail;
      case "loginVerifyRequired":
        // For login-required routes, check if user is verified
        return Boolean(
          authState.isAuthenticated && authState.user?.is_verified
        );
      default:
        return false;
    }
  };

  const getRedirectPath = (path) => {
    if (
      path === "/trackco/login/success" ||
      path === "/trackco/signup-verification"
    ) {
      window.location.href = "https://www.smartkood.com/";
      return null;
    }
    return null;
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        // If the user is authorized, render the component
        if (isAuthorized()) {
          return <Component {...props} />;
        } else {
          const redirectPath = getRedirectPath(props.match.path);
          if (redirectPath) {
            return (
              <Redirect
                to={{
                  pathname: redirectPath,
                  state: { from: props.location },
                }}
              />
            );
          }
          return null;
        }
      }}
    />
  );
};

export default ProtectedRoute;
